// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrapper[data-v-36d8d2c1]{height:100vh;overflow:auto}.test[data-v-36d8d2c1]{display:none}.main-content[data-v-36d8d2c1]{display:grid;grid-template-columns:1fr;margin:0!important;position:relative;z-index:0}.main-column[data-v-36d8d2c1]{max-width:100vw;padding:0!important;width:100%}.left-gutter[data-v-36d8d2c1],.right-gutter[data-v-36d8d2c1]{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
